import { Collapse } from 'antd'
import { InterventionForm } from './InterventionForm'
import { bbvQuery, waardeDagQuery, waardeNachtQuery, afsluitingenQuery, bugfixQuery } from './queries'
import {
  performIntervention,
} from './helpers'
import {
  AfsluitingenRecordList,
  createAfsluitingenIntervention,
  mapAfsluitingenIntervention,
} from './AfsluitingenRecordList'
import {
  BbvRecordList,
  WaardeDagNachtRecordList,
  createBbvIntervention,
  createWaardeDagNachtIntervention,
  mapBbvIntervention,
} from './BbvRecordList'
import {
  BugfixRecordList,
  mapBugfixIntervention,
} from './BugfixRecordList'

const { Panel } = Collapse

const Interventies = ({ quarter, quarters }) => {

  return (
    <Collapse
      style={{ height: '100%' }}
      accordion={true}
      defaultActiveKey={['1']}
    >
      <Panel header='BBV Interventies' key='1'>
        <InterventionForm
          quarter={quarter}
          quarters={quarters}
          name='BBV'
          query={bbvQuery}
          writeFn={createBbvIntervention}
          mapInterventionFn={mapBbvIntervention('bbvq')}
          RecordList={BbvRecordList}
          secondaryAction={performIntervention}
        />
      </Panel>
      <Panel header='Waarde Dag Interventies' key='2'>
        <InterventionForm
          quarter={quarter}
          quarters={quarters}
          name='WaardeDag'
          query={waardeDagQuery}
          writeFn={createWaardeDagNachtIntervention}
          mapInterventionFn={mapBbvIntervention('waarde')}
          RecordList={WaardeDagNachtRecordList('WaardeDag')}
          secondaryAction={performIntervention}
        />
      </Panel>
      <Panel header='Waarde Nacht Interventies' key='3'>
        <InterventionForm
          quarter={quarter}
          quarters={quarters}
          name='WaardeNacht'
          query={waardeNachtQuery}
          writeFn={createWaardeDagNachtIntervention}
          mapInterventionFn={mapBbvIntervention('waarde')}
          RecordList={WaardeDagNachtRecordList('WaardeNacht')}
          secondaryAction={performIntervention}
        />
      </Panel>
      <Panel header='Afsluitingen Interventies' key='4'>
        <InterventionForm
          quarter={quarter}
          quarters={quarters}
          name='Afsluitingen'
          query={afsluitingenQuery}
          writeFn={createAfsluitingenIntervention}
          mapInterventionFn={mapAfsluitingenIntervention}
          RecordList={AfsluitingenRecordList}
          secondaryAction={performIntervention}
        />
      </Panel>
      <Panel header='Data bugfixes' key='5'>
        <InterventionForm
          quarter={quarter}
          quarters={quarters}
          name='Bugfix'
          query={bugfixQuery}
          mapInterventionFn={mapBugfixIntervention}
          RecordList={BugfixRecordList}
          secondaryAction={performIntervention}
        />
      </Panel>
    </Collapse>
  )
}

Interventies.title = "Interventies"

export default Interventies
